// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"680":"ad092242","835":"f22aa314"}[chunkId] + ".chunk.css";
};